import HttpRequest from './HttpRequest'
import { getAuthToken } from '@/utils/js/Auth'
export default class AccessLogProvider extends HttpRequest {
  getAccessLog (query) {
    this.setHeader(getAuthToken())
    return this.get(`/access-logs?${query}`)
  }
}
